var effect = new TimelineMax({paused: true})
    .addLabel('init')
    .add(function() {
        $('.effect', '.h-con').removeClass('twink');
    }, 'init')
    .fromTo($('.h-con__date', '.h-con'), 1, {autoAlpha: 0, y: 100}, {autoAlpha: 1, y: 0, ease: Power2.easeOut}, 'init+=1.0')
    .fromTo($('.h-con__tit', '.h-con'), 1, {autoAlpha: 0, y: 100}, {autoAlpha: 1, y: 0, ease: Power2.easeOut}, 'init+=1.15')
    .fromTo($('.h-con__text', '.h-con'), 1, {autoAlpha: 0, y: 100}, {autoAlpha: 1, y: 0, ease: Power2.easeOut}, 'init+=1.55')
    .fromTo($('.h-con__desc1', '.h-con'), 1, {autoAlpha: 0, y: 100}, {autoAlpha: 1, y: 0, ease: Power2.easeOut}, 'init+=2.45')
    .fromTo($('.h-con__desc2', '.h-con'), 1, {autoAlpha: 0, y: 50}, {autoAlpha: 1, y: 0, ease: Power2.easeOut}, 'init+=2.78')
    .fromTo($('.h-con__desc3', '.h-con'), 1, {autoAlpha: 0, y: 50}, {autoAlpha: 1, y: 0, ease: Power2.easeOut}, 'init+=2.8')
    .fromTo($('.h-con__char1', '.h-con'), 3, {autoAlpha: 1, x: 180}, {autoAlpha: 1, x: 0, ease: Power3.easeOut}, 'init+=0.3')
    .fromTo($('.h-con__char2', '.h-con'), 3, {autoAlpha: 1, x: -180}, {autoAlpha: 1, x: 0, ease: Power3.easeOut}, 'init+=0.3')
    .fromTo($('.u-banner'), .8, {autoAlpha: 0}, {autoAlpha: 1, ease: Power2.easeOut}, 'init+=1.5')
    .add(function() {
        $('.effect', '.h-con').addClass('twink');
        $('.effect', '.c-con').addClass('twink');
    }, 'init+=1.45');

//setMovie
var movie = {
    mainMovie: promokit.videoplayer({
        el: '#playerIndex',
        url: 'https://vod.plaync.com/lineage2/promo/highlight.mp4',
        controls: false,
        autoplay: false,
        loop: true,
        mute: true
    }),
    tab1: [],
    tab2: [],
    nowPlay: null,
    skill: {
        tab1: { // 싱어
            0: { // 익스트림 템포
                el: '#movie-skill1-1',
                youtubeId: 'WOBy-0gejks'
            },
            1: { // 매드니스 비트
                el: '#movie-skill1-2',
                youtubeId: 'szLKg88q_jM'
            },
            2: { // 송 오브 헌터
                el: '#movie-skill1-3',
                youtubeId: 'wo2_B2isaMU'
            },
            3: { // 송 오브 어스
                el: '#movie-skill1-4',
                youtubeId: 'tAzhrtI5vFQ'
            },
            4: { // 소드 가드
                el: '#movie-skill1-5',
                youtubeId: 'JRRJ8Zrk7mo'
            },
            5: { // 소드 심포니
                el: '#movie-skill1-6',
                youtubeId: 'for4c5GzZn0'
            },
            6: { // 소드 블레싱
                el: '#movie-skill1-7',
                youtubeId: 't9MaPQIvWeg'
            }
        },
        tab2: { // 댄서
            0: { // 익스트림 템포
                el: '#movie-skill2-1',
                youtubeId: 'ljksyLX81VE'
            },
            1: { // 매드니스 왈츠
                el: '#movie-skill2-2',
                youtubeId: 'TIIFjuaDsVo'
            },
            2: { // 댄스 오브 워리어
                el: '#movie-skill2-3',
                youtubeId: 'XcRSeNyPy4M'
            },
            3: { // 댄스 오브 파이어
                el: '#movie-skill2-4',
                youtubeId: 'NMXKXoR0_6I'
            },
            4: { // 포이즌 커스
                el: '#movie-skill2-5',
                youtubeId: 'sTb-60HfNJM'
            },
            5: { // 포이즌 댄스
                el: '#movie-skill2-6',
                youtubeId: 'I7zF-fj8x3w'
            },
            6: { // 포이즌 에너
                el: '#movie-skill2-7',
                youtubeId: 'v3PAW-xXRwk'
            }
        }
    }
};
var moviePlay = function(tabIndex, currId) {
    if (!movie['tab' + tabIndex][currId]) {
        movie['tab' + tabIndex][currId] = promokit.youtubeplayer({
            el: movie.skill['tab' + tabIndex][currId].el,
            youtubeId: movie.skill['tab' + tabIndex][currId].youtubeId,
            loop: true,
            mute: true
        });
    }
    movie.nowPlay && movie.nowPlay.pause();
    movie['tab' + tabIndex][currId].play();
    movie.nowPlay = movie['tab' + tabIndex][currId];
};

//tab
var TabMenu = function(index) {
    var current = index;
    var elWrap = $('#skill-tab');
    var elTabWrap = elWrap.find('.tab-menu');
    var elTabMenu = elTabWrap.find('.tab-menu__list');
    var elConWrap = elWrap.find('.tab-con--wrap');
    var elConList = elConWrap.find('.tab-con');

    switch (current) {
        case 0 :
            elTabMenu.removeClass('tab-menu__list--on')
                .eq(0)
                .addClass('tab-menu__list--on');
            elConList.removeClass('tab-con--on')
                .eq(0)
                .addClass('tab-con--on');
            $('.skill-menu__skill1').find('a')
                .removeClass('active')
                .eq(0).addClass('active');
            $('#slider-skill-1').slick('slickGoTo', 0);
            moviePlay(1, 0);
            break;

        case 1 :
            elTabMenu.removeClass('tab-menu__list--on')
                .eq(1)
                .addClass('tab-menu__list--on');
            elConList.removeClass('tab-con--on')
                .eq(1)
                .addClass('tab-con--on');
            $('.skill-menu__skill2').find('a')
                .removeClass('active')
                .eq(0)
                .addClass('active');
            $('#slider-skill-2').slick('slickGoTo', 0);
            moviePlay(2, 0);
            break;
    }

    elTabMenu.find('button')
        .off('click')
        .on('click', function() {
            TabMenu($(this).data('index'));
        });
};

//skill
$('#slider-skill-1').slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    speed: 500,
    fade: true,
    dots: false,
    draggable: false,
    arrows: true
});
$('#slider-skill-2').slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    speed: 500,
    fade: true,
    dots: false,
    draggable: false,
    arrows: true
});

$('#slider-skill-1').on('beforeChange', function(event, slick, currentSlide, nextSlide) {
    moviePlay(1, nextSlide);
    $('.skill-menu__skill1').find('a')
        .removeClass('active')
        .eq(nextSlide)
        .addClass('active');
});
$('#slider-skill-2').on('beforeChange', function(event, slick, currentSlide, nextSlide) {
    moviePlay(2, nextSlide);
    $('.skill-menu__skill2').find('a')
        .removeClass('active')
        .eq(nextSlide)
        .addClass('active');
});

$('a', '.skill-menu__skill1').on('click', function(e) {
    e.preventDefault();
    $('#slider-skill-1').slick('slickGoTo', $(this).data('index'));
});
$('a', '.skill-menu__skill2').on('click', function(e) {
    e.preventDefault();
    $('#slider-skill-2').slick('slickGoTo', $(this).data('index'));
});

$('.h-con__scroll').on('click', function(e) {
    e.preventDefault();
    var target = $('#section-1'),
        offsetTop = $(target).offset().top;
    var $doc = $('html, body');
    $doc.stop()
        .animate({
            scrollTop: offsetTop
        }, 800);
});

$('.u-banner__close').on('click', function() {
    $('.u-banner').hide();
});

//preload
promokit.preload({
    game: 'lineage2',
    complete: function() {
        TabMenu(0);

        effect.play();
        movie.mainMovie.play();
    }
});



// WEBPACK FOOTER //
// ./src/js/index.js